const Loading = ({ size = 'md', text = '' }) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  }
  
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className={`spinner ${sizes[size]}`} />
      {text && <p className="mt-3 text-brand-slate">{text}</p>}
    </div>
  )
}

export default Loading


